import { BehaviorSubject } from 'rxjs'
import { SocialNetworksAvailables } from '../interfaces/socialnetworks.interface'
interface ISocialNetworkConnection {
  socialNetwork?: SocialNetworksAvailables
  connect?: boolean
  codeForInstagramTutorial?: string
}
export default new BehaviorSubject<ISocialNetworkConnection | null>(null)
